import AwsAccountObject, { AWS_ACCOUNT_OBJECT } from 'gql/AwsAccountObject';
import GlobalServiceObject, { GLOBAL_SERVICE } from 'gql/GlobalService';
import KubernetesClusterObject, { KUBERNETES_CLUSTER } from 'gql/KubernetesCluster';
import { IDed, RequestTargetType } from 'gql/Request';
import { SingletonResult } from 'gql/Common';
import { FULL_TARGET_GROUP, TargetGroup } from 'gql/TargetGroup';
import Helper from 'utils/Helper';
import Audit from 'gql/Audit';
import Approval from 'gql/Approval';
import { EosService, FULL_EOS_SERVICE } from './EosService';

interface AuditFields {
  createdBy: string;
  createdAt: string;
  updatedBy?: string;
  updatedAt?: string;
}

export interface ChangeSet extends IDed {
  createdBy: string;
  createdAt: string;
  requestId: string;
  targetID: string;
  proposedValue: string;
  proposedAwsAccountObject?: AwsAccountObject;
  proposedGlobalServiceObject?: GlobalServiceObject;
  proposedKubernetesCluster?: KubernetesClusterObject;
  proposedTargetGroup?: TargetGroup;
  proposedEOSServiceObject?: EosService;
}

export interface BaseChangeRequest {
  targetType: RequestTargetType;
  targetId: string;
  targetName: string;
  accessLevel: number;
  isApproved: boolean;
  isRejected: boolean;
  canAcceptOrReject: boolean;
  requestCloseTime: string;
  approvals: Approval[];
  audits: Audit[];
  changes: ChangeSet[];
}
export interface ChangeRequest extends IDed, AuditFields, BaseChangeRequest {
  deleted?: boolean;
}

export const FULL_CHANGE_REQUEST = `
{
    id
    createdBy
    createdAt
    updatedBy
    updatedAt
    targetType
    targetId
    targetName
    accessLevel
    isApproved
    isRejected
    canAcceptOrReject
    requestCloseTime
    approvals {
        id
        createdBy
        createdAt
        updatedBy
        updatedAt
        requestId
        acceptedBy
        acceptedAt
        rejectedBy
        rejectedAt
        canAccept
        canReject
    }
    audits {
        id
        createdBy
        createdAt
        updatedBy
        updatedAt
        requestId
        diffs {
            member
            oldValue
            newValue
        }
        oldImage
        newImage
        eventName
        itemType
    }
    changes {
        id
        createdBy
        createdAt
        targetID
        proposedValue
        proposedAwsAccountObject ${AWS_ACCOUNT_OBJECT}
        proposedEOSServiceObject ${FULL_EOS_SERVICE}
        proposedGlobalServiceObject ${GLOBAL_SERVICE}
        proposedKubernetesCluster ${KUBERNETES_CLUSTER}
        proposedTargetGroup ${FULL_TARGET_GROUP}
    }
}`;

const GET_CHANGE_REQUEST = `
  query getChangeRequest($id: String!) {
    getChangeRequest(id: $id) {
      item ${FULL_CHANGE_REQUEST}
    }
  }`;

export const getChangeRequest = async (id: string): Promise<ChangeRequest> => {
  const result = await Helper.execGQL<SingletonResult<ChangeRequest>>({
    query: GET_CHANGE_REQUEST,
    variables: {
      id,
    },
  });
  return result.getChangeRequest.item;
};
